import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { memo, useEffect, useState } from "react";
import { AuthenticationState } from "react-aad-msal";
import { Button as StateButton } from "../forms/elements"; //ga tracker

import gaTracker from "../../util/ga-analytics/gaTracker";
import MediaQuery from "react-responsive";

var CartContinue = function CartContinue(props) {
  var _document$getElementB, _document$getElementB2;

  var _props$authentication = props.authenticationState,
      authenticationState = _props$authentication === void 0 ? AuthenticationState.Unauthenticated : _props$authentication,
      isCater = props.isCater,
      handleLogin = props.handleLogin,
      isFood = props.isFood,
      isRetail = props.isRetail,
      cart = props.cart,
      _props$values = props.values,
      values = _props$values === void 0 ? {} : _props$values,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? {} : _props$errors,
      setTime = props.setTime,
      isValidatingTimeWanted = props.isValidatingTimeWanted,
      _props$saveDeliveryMo = props.saveDeliveryMode,
      saveDeliveryMode = _props$saveDeliveryMo === void 0 ? function (delivery) {
    return console.log("setTime", delivery);
  } : _props$saveDeliveryMo,
      goToCheckout = props.goToCheckout,
      _props$resetGoToCheck = props.resetGoToCheckout,
      resetGoToCheckout = _props$resetGoToCheck === void 0 ? function () {
    return console.log("resetGoToCheckout");
  } : _props$resetGoToCheck,
      _props$limitModel = props.limitModel,
      limitModel = _props$limitModel === void 0 ? {} : _props$limitModel,
      disabled = props.disabled;
  var isDisabled = disabled || !(isCater || isFood || isRetail) || Object.values(errors).length != 0;

  var continueGuestClick = function continueGuestClick() {
    var info = JSON.stringify(cart.map(function (product) {
      return {
        id: product.Id,
        quantity: product.Quantity
      };
    }));
    var data = {
      gtm: {
        uniqueEventId: "104",
        elementId: "continue"
      },
      event: "gtm.click"
    };
    gaTracker(data);
  };

  var cartClick = function cartClick() {
    var info = JSON.stringify(cart.map(function (product) {
      return {
        id: product.Id,
        quantity: product.Quantity
      };
    }));
    var data = {
      gtm: {
        uniqueEventId: "105",
        targetElement: info,
        elementId: "checkout"
      },
      event: "gtm.click"
    };
    gaTracker(data);
  };

  var signInClick = function signInClick() {
    var data = {
      gtm: {
        uniqueEventId: "103",
        elementId: "signin"
      },
      event: "gtm.click"
    };
    gaTracker(data);
  };

  var signIn = function signIn() {
    var _limitModel$Unauthent, _limitModel$Unauthent2, _limitModel$Unauthent3, _limitModel$Unauthent4, _limitModel$Unauthent5;

    if (limitModel === null || limitModel === void 0 ? void 0 : (_limitModel$Unauthent = limitModel.UnauthenticatedModule) === null || _limitModel$Unauthent === void 0 ? void 0 : (_limitModel$Unauthent2 = _limitModel$Unauthent[0]) === null || _limitModel$Unauthent2 === void 0 ? void 0 : (_limitModel$Unauthent3 = _limitModel$Unauthent2.fields) === null || _limitModel$Unauthent3 === void 0 ? void 0 : (_limitModel$Unauthent4 = _limitModel$Unauthent3.SignInButton) === null || _limitModel$Unauthent4 === void 0 ? void 0 : (_limitModel$Unauthent5 = _limitModel$Unauthent4.value) === null || _limitModel$Unauthent5 === void 0 ? void 0 : _limitModel$Unauthent5.href) {
      var _limitModel$Unauthent6, _limitModel$Unauthent7, _limitModel$Unauthent8, _limitModel$Unauthent9, _limitModel$Unauthent10;

      window.location.href = limitModel === null || limitModel === void 0 ? void 0 : (_limitModel$Unauthent6 = limitModel.UnauthenticatedModule) === null || _limitModel$Unauthent6 === void 0 ? void 0 : (_limitModel$Unauthent7 = _limitModel$Unauthent6[0]) === null || _limitModel$Unauthent7 === void 0 ? void 0 : (_limitModel$Unauthent8 = _limitModel$Unauthent7.fields) === null || _limitModel$Unauthent8 === void 0 ? void 0 : (_limitModel$Unauthent9 = _limitModel$Unauthent8.SignInButton) === null || _limitModel$Unauthent9 === void 0 ? void 0 : (_limitModel$Unauthent10 = _limitModel$Unauthent9.value) === null || _limitModel$Unauthent10 === void 0 ? void 0 : _limitModel$Unauthent10.href;
    } else {
      if (typeof handleLogin === 'function') {
        return handleLogin();
      }
    }
  };

  var validatePage = function validatePage() {
    var travel = {
      retailDeliveryMode: isRetail ? values.retailDelivery || null : null,
      foodDeliveryMode: isFood ? values.foodDelivery || null : null,
      caterDeliveryMode: isCater ? values.cateringDelivery || null : null
    }; //setdelivery mode now found in checkout page

    saveDeliveryMode(travel);

    var timeWanted = _objectSpread({
      foodTimeWanted: null,
      caterTimeWanted: null
    }, travel);

    var foodType = values.foodTime;
    var caterType = values.cateringTime;

    if (isCater && caterType === "scheduled") {
      if (values.cateringDueTime && values.cateringDate) {
        timeWanted.caterTimeWanted = {
          time: values.cateringDueTime,
          date: values.cateringDate
        };
      } else {
        setTime(timeWanted);
        return console.log("CATER, error");
      }
    }

    if (isFood && foodType === "scheduled") {
      if (values.foodDueTime && values.foodDate) {
        timeWanted.foodTimeWanted = {
          time: values.foodDueTime,
          date: values.foodDate
        };
      } else {
        setTime(timeWanted);
        return console.log("FOOD, error");
      }
    }

    if (isFood && foodType === "asap") {
      if (values.foodDueTime) {
        timeWanted.foodTimeWanted = {
          time: null,
          date: null
        };
      } else {
        setTime(timeWanted);
        return console.log("FOOD, error");
      }
    }

    if ((isCater || isFood) && (caterType === "scheduled" || foodType === "scheduled" || foodType === "asap")) {
      //Figure out time here
      return setTime(timeWanted);
    } else {
      return resetGoToCheckout(true);
    }
  };

  var bottom = ((_document$getElementB = document.getElementById('cb-mobile-bottom-tabs')) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.style) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.height) || '0px';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement("div", {
    id: "mobileCartContinue",
    class: "cb-content-block cb-cart__continue w-100",
    style: {
      paddingTop: "10px",
      paddingBottom: "10px",
      position: "fixed",
      bottom: "0px",
      zIndex: 99
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-100",
    style: {
      paddingBottom: "10px"
    }
  }, authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "w-100 cb-button-secondary",
    disabled: isDisabled,
    loading: isValidatingTimeWanted,
    id: "continue",
    onClick: function onClick() {
      continueGuestClick();
      validatePage();
    }
  }, "Continue as Guest")), /*#__PURE__*/React.createElement("div", {
    className: "w-100",
    style: {
      paddingBottom: "15px"
    }
  }, authenticationState === AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "w-100 cb-button-primary",
    disabled: isDisabled,
    loading: isValidatingTimeWanted,
    id: "checkout",
    onClick: function onClick() {
      cartClick();
      validatePage();
    }
  }, "Continue"), authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "w-100 cb-button-primary",
    disabled: isDisabled,
    id: "signin",
    onClick: function onClick() {
      signInClick();
      signIn();
    }
  }, " ", "Sign In And Continue")))))), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement("div", {
    class: "cb-content-block cb-cart__continue w-100",
    style: {
      paddingTop: "10px",
      paddingBottom: "10px",
      position: "fixed",
      bottom: bottom,
      zIndex: 99,
      borderTop: "outset 4px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingRight: "10%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    class: "row"
  }, /*#__PURE__*/React.createElement("div", {
    class: "col"
  }, /*#__PURE__*/React.createElement("div", {
    class: "d-flex flex-row-reverse"
  }, authenticationState === AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "p2 cb-button-primary",
    disabled: isDisabled,
    loading: isValidatingTimeWanted,
    id: "checkout",
    onClick: function onClick() {
      cartClick();
      validatePage();
    }
  }, "Continue"), authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "p2 cb-button-primary",
    disabled: isDisabled,
    id: "signin",
    onClick: function onClick() {
      signInClick();
      signIn();
    }
  }, " ", "Sign In And Continue"), /*#__PURE__*/React.createElement("div", {
    class: "p-2"
  }), authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "p2 cb-button-secondary",
    disabled: isDisabled,
    loading: isValidatingTimeWanted,
    id: "continue",
    onClick: function onClick() {
      continueGuestClick();
      validatePage();
    }
  }, "Continue as Guest"))))))));
};

export default CartContinue;